import Model, { attr, belongsTo, hasMany } from '@ember-data/model';
import EmberArray from '@ember/array';
import JournalDashboardModel from '../journal-dashboard';
import JournalModel from '../journal';
import JournalDecisionModel from '../journal-decision';

export default class JournalDigestModel extends Model {
  @attr('string') journalId!: string;
  @belongsTo('journal', { async: false, inverse: null }) journal!: JournalModel;
  @belongsTo('journal-dashboard', { async: false, inverse: null })
  journalDashboard!: JournalDashboardModel;
  @hasMany('journal-decision', { async: false, inverse: null })
  journalDecisions!: EmberArray<JournalDecisionModel>;
}

declare module 'ember-data/types/registries/model' {
  export default interface ModelRegistry {
    'all-funds/journal-digest': JournalDigestModel;
  }
}
